import  { core as SmartyCore, usAutocompletePro, usStreet, usReverseGeo  } from "smartystreets-javascript-sdk"

const credentials = new SmartyCore.SharedCredentials(process.env.REACT_APP_SMARTYSTREETS_API_KEY || '14325476671196733');

export const AutoCompleteLookup = usAutocompletePro.Lookup;
export const StreetLookup = usStreet.Lookup;
export const ReverseLookup = usReverseGeo.Lookup
export const Suggestion = usAutocompletePro.Suggestion;

export const streetSearchClient = new SmartyCore.ClientBuilder(credentials).buildUsStreetApiClient();
export const autocompleteClient = new SmartyCore.ClientBuilder(credentials).withLicenses(["us-autocomplete-pro-cloud"]).buildUsAutocompleteProClient();
export const reverseLookupClient = new SmartyCore.ClientBuilder(credentials).buildUsReverseGeoClient();
